import { Component, inject, Input, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { SERVICE_ENDPOINTS } from '../../../../../core/configs/service-endpoints';
import { HelperService } from '../../../../../core/services/helper.service';
import { I18nService } from '../../../../../core/services/i18n.service';
import { ShopType } from '../../../../enums/organisation/shop-type';
import { OrganisationData } from '../../../../interfaces/organisation/organisation-data';
import { OrganisationShopConfigData } from '../../../../interfaces/organisation/organisation-shop-config-data';
import { PaymentData } from '../../../../interfaces/payment/payment-data';
import { CustomerDataService } from '../../../../services/customer-data.service';
import { SettingsProviderService } from '../../../../services/settings-provider.service';

@Component({
  selector: 'admin-payment-type-activation',
  imports: [
    FormsModule,
    InputText,
    Select
  ],
  templateUrl: './admin-payment-type-activation.component.html',
})
export class AdminPaymentTypeActivationComponent implements OnInit {

  loading = true;
  i18n = inject(I18nService);
  helper = inject(HelperService);
  messageService = inject(MessageService);
  customerDataService = inject(CustomerDataService);
  settingsProvider = inject(SettingsProviderService);

  @Input() tenantId: string;
  @Input() paymentData: PaymentData;
  shopDataChanged = output<OrganisationShopConfigData>();
  forceCloseDialog = output<boolean>();
  activationEnabled = output<boolean>();

  organisationData: OrganisationData = {};
  /**
   * No reference on parent shop data because referbec goes lost when dialog is destroyed
   */
  editShopData: OrganisationShopConfigData;

  ngOnInit(): void {
    this.getOrganisationData();
  }

  /**
   * get organisation data from backend
   * @private
   */
  private getOrganisationData() {
    this.customerDataService.findById(SERVICE_ENDPOINTS.GET_ORGANISATION, this.tenantId).subscribe({
      next: result => {
        if (result.successful) {
          this.organisationData = result.dto;
          this.editShopData = {
            // tenantId: this.tenantId,
            tenantId: this.organisationData.displayCustomerNumber,   // Changed to the display-customer-number 02.11.1027
            shopType: ShopType.RETAIL,
          }
          this.shopDataChanged.emit(this.editShopData);
          this.loading = false;
          this.checkValidActivationData();
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'error',
            summary: this.i18n.i18nLng()['HTTPDATAERROR'],
            detail: result.message + '\n' + result.details + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
          });
          this.forceCloseDialog.emit(true);
        }
      },
      error: err => {
        this.messageService.add({
          sticky: true,
          severity: 'error',
          summary: this.i18n.i18nLng()['HTTPDATAERROR'],
          detail: err.message + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
        });
        this.forceCloseDialog.emit(true);
      }
    })
  }

  /**
   * emit the changed data
   */
  dataChanged(): void {
    this.shopDataChanged.emit(this.editShopData);
  }

  /**
   * check for valid organisation data and enable/disable Next-Button
   * @private
   */
  private checkValidActivationData() {
    let valid: boolean = true;
    if (!this.organisationData?.name || this.organisationData?.name.trim().length === 0) {
      valid = false;
    }
    if (!this.organisationData?.streetNr || this.organisationData?.streetNr.trim().length === 0) {
      valid = false;
    }
    if (!this.organisationData?.postalCode || this.organisationData?.postalCode.trim().length === 0) {
      valid = false;
    }
    if (!this.organisationData?.city || this.organisationData?.city.trim().length === 0) {
      valid = false;
    }
    if (!this.organisationData?.url || this.organisationData?.url.trim().length === 0) {
      valid = false;
    }
    if (!valid) {
      this.messageService.add({
        life: 4000,
        severity: 'info',
        summary: this.i18n.i18nLng()['INFORMATION'],
        detail: this.i18n.i18nLng()['ACTIVATIONDATAINCOMPLETE']
      });
      this.activationEnabled.emit(false);
    } else {
      this.activationEnabled.emit(true);
    }
  }
}
